import { all, put, call, take, takeLatest, select } from 'redux-saga/effects';
import { zwalletPaymentGraphQL, zwalletPaymentConfirmGraphQL, zwalletPaymentNotSupportedGraphQL } from './graphql';
import { setForm, setState } from './actions';
import {
  BARCODE_NOT_FOUND, NOT_SUPPORTED_BILL, CHANGE_FORM,
  PAYMENT_CONFIRM, PAYMENT_NOT_SUPPORTED
} from './types';
import { loadOperationsAction } from '../Operations/actions';
import { loadDashboardCards } from '../Dashboard/actions';
import { errorAlert, successAlert } from '../../Common/alerts';

function* zwalletPayment(action) {
  const { payload } = action;

  try {
      const user = yield select(state => state.user);

      const { dueDate, totalValue, protocol } = yield call(zwalletPaymentGraphQL, { payload, user });

      const data = {
        barcode: payload.barcode,
        description: payload.description,
        dueDate: dueDate,
        bank: "633", // banco rendimento
        amount: totalValue,
        protocol: protocol
      }

      yield put(setForm(data));
      yield put(setState({ form2: true, redirect: false, supported: true }));
  } catch(error) {
    if (error == BARCODE_NOT_FOUND || error == NOT_SUPPORTED_BILL) {
      const data = {
        barcode: payload.barcode,
        description: payload.description,
        dueDate: "",
        bank: "",
        amount: ""
      }

      yield put(setForm(data));
      yield put(setState({ form2: true, redirect: false, supported: false }));
    } else {
      errorAlert("Ops...", error);
    }
  }
}

function* watchZwalletPayment() {
  yield takeLatest(CHANGE_FORM, zwalletPayment);
}


function* zwalletPaymentConfirm(action) {
  const { protocol, dueDate } = action.payload;

  try {
      yield call(zwalletPaymentConfirmGraphQL, { protocol, dueDate });

      yield put(loadOperationsAction({ filter: "", value: ""}));
      yield put(loadDashboardCards());
      yield take(["SET_OPERATIONS", "DASHBOARD_CARDS_VALUE"]);

      successAlert(
        "Pagamento realizado",
        "Pagamento realizado com sucesso! comprovante já está disponível para ser baixado."
      );

      yield put(setState({ form2: true, redirect: true, supported: true }));
  } catch(error) {
    errorAlert("Ops...", error);
  }
}

function* watchZwalletPaymentConfirm() {
  yield takeLatest(PAYMENT_CONFIRM, zwalletPaymentConfirm);
}


function* zwalletPaymentNotSupported(action) {
  const { payload } = action;

  try {
      const user = yield select(state => state.user);

      yield call(zwalletPaymentNotSupportedGraphQL, { payload, user });

      yield put(loadOperationsAction({ filter: "", value: ""}));
      yield put(loadDashboardCards());
      yield take(["SET_OPERATIONS", "DASHBOARD_CARDS_VALUE"]);

      successAlert(
        "Pagamento enviado",
        "Pagamento enviado com sucesso, o pagamento será confirmado em breve e o comprovante estará disponível para ser baixado."
      );

      yield put(setState({ form2: true, redirect: true, supported: false }));
  } catch(error) {
    errorAlert("Ops...", error);
  }
}

function* watchZwalletPaymentNotSupported() {
  yield takeLatest(PAYMENT_NOT_SUPPORTED, zwalletPaymentNotSupported);
}


export default function* rootSaga() {
  yield all([
    watchZwalletPayment(),
    watchZwalletPaymentConfirm(),
    watchZwalletPaymentNotSupported()
  ]);
}


// WEBPACK FOOTER //
// ./src/ZWallet/Payment/sagas.js